import React from "react";
import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
// all pages
import {
  CurrentPlanPage,
  HomePage,
  Dashboard,
  WelcomePage,
  Denied,
  MenuPages,
  InvitePage,
} from "./pages";
// constants
import ROUTES from "./constants/routes";
import "../../node_modules/react-modal-video/scss/modal-video.scss";
import "react-calendar/dist/Calendar.css";
import { History } from "../services";
import PrivateRoute from "./routing/privateRoute";
import { connect } from "react-redux";
import { logout } from "../redux/actions/login";
import NRPMain from "../NRP";
import PaymentConfirmation from "../paymentConfirmation";

function GCPFreeVersionRoutes(props) {
  console.log(
    "%c  Free Version SAAS Production Mode!",
    "width: 100% ; border: 3px solid yellow ; border-radius: 7px ; font-weight:bold; " +
      "padding: 10px; margin: 20px;"
  );

  return (
    <HashRouter hashType="noslash">
      <Routes history={History}>
        <Route
          path={`/`}
          element={
            <PrivateRoute>
              <CurrentPlanPage />
            </PrivateRoute>
          }
        />
        <Route
          path={`${ROUTES.WELCOME}`}
          element={
            <PrivateRoute>
              <WelcomePage />
            </PrivateRoute>
          }
        />
        <Route
          path={`${ROUTES.HOME}`}
          element={
            <PrivateRoute>
              <HomePage />
            </PrivateRoute>
          }
        />

        <Route
          path={`${ROUTES.DASHBOARD}`}
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />

        <Route
          path={`${ROUTES.REPORT}`}
          element={
            <PrivateRoute>
              <NRPMain />
            </PrivateRoute>
          }
        />

        <Route
          path={`${ROUTES.INVITE}`}
          element={
            <PrivateRoute>
              <InvitePage />
            </PrivateRoute>
          }
        />
        <Route
          path={`${ROUTES.MENUPAGES}`}
          element={
            <PrivateRoute>
              <MenuPages />
            </PrivateRoute>
          }
        />
        <Route path={`/confirmation`} element={<PaymentConfirmation />} />
        <Route exact={true} path="/404" element={<Denied />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
    </HashRouter>
  );
}
const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, { logout })(GCPFreeVersionRoutes);
